var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBottomArrow = function SvgIconBottomArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 8,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#422800",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.684.94 4.342 4.28 1 .94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.684 3.658 4.342 7 1 3.658"
  }))));
};
export default SvgIconBottomArrow;